import { useEffect, useState } from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";
import { colors } from "../utils/design";

const DISPLAY_DELAY = 500;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export const LoadingPage: React.FC = () => {
  const [isHidden, setIsHidden] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsHidden(false);
    }, DISPLAY_DELAY);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <View style={styles.container}>
      {!isHidden && <ActivityIndicator size="small" color={colors.primary[500]} />}
    </View>
  );
};
